// Approximate coordinates for the center of various districts in Tanzania.
export const districtCoordinates = {
    // Arusha Region
    "Arusha City": { lat: -3.3869, lng: 36.6829 },
    "Arusha Rural": { lat: -3.371, lng: 36.693 },
    "Karatu": { lat: -3.345, lng: 35.671 },
    "Longido": { lat: -2.716, lng: 36.683 },
    "Meru": { lat: -3.233, lng: 36.850 },
    "Monduli": { lat: -3.300, lng: 36.450 },
    "Ngorongoro": { lat: -2.766, lng: 35.483 },
    // Dar es Salaam Region
    "Ilala": { lat: -6.8229, lng: 39.2694 },
    "Kinondoni": { lat: -6.772, lng: 39.2311 },
    "Temeke": { lat: -6.8687, lng: 39.2885 },
    "Kigamboni": { lat: -6.852, lng: 39.362 },
    "Ubungo": { lat: -6.793, lng: 39.208 },
    // Dodoma Region
    "Bahi": { lat: -6.183, lng: 35.317 },
    "Chamwino": { lat: -6.100, lng: 36.150 },
    "Chemba": { lat: -5.150, lng: 35.817 },
    "Dodoma Urban": { lat: -6.1731, lng: 35.7419 },
    "Kondoa": { lat: -4.900, lng: 35.783 },
    "Kongwa": { lat: -6.167, lng: 36.417 },
    "Mpwapwa": { lat: -6.350, lng: 36.483 },
    // Geita Region
    "Bukombe": { lat: -3.567, lng: 31.883 },
    "Chato": { lat: -2.633, lng: 31.767 },
    "Geita": { lat: -2.867, lng: 32.233 },
    "Mbogwe": { lat: -3.367, lng: 32.233 },
    "Nyang'hwale": { lat: -3.000, lng: 32.733 },
    // Iringa Region
    "Iringa Urban": { lat: -7.766, lng: 35.700 },
    "Iringa Rural": { lat: -7.833, lng: 35.750 },
    "Kilolo": { lat: -7.867, lng: 36.083 },
    "Mufindi": { lat: -8.600, lng: 35.283 },
    // Kagera Region
    "Biharamulo": { lat: -2.633, lng: 31.300 },
    "Bukoba Urban": { lat: -1.333, lng: 31.817 },
    "Bukoba Rural": { lat: -1.500, lng: 31.667 },
    "Karagwe": { lat: -1.567, lng: 30.950 },
    "Kyerwa": { lat: -1.250, lng: 30.783 },
    "Missenyi": { lat: -1.167, lng: 31.417 },
    "Muleba": { lat: -1.833, lng: 31.650 },
    "Ngara": { lat: -2.517, lng: 30.650 },
    // Katavi Region
    "Mlele": { lat: -6.500, lng: 31.500 },
    "Mpanda": { lat: -6.350, lng: 31.067 },
    // Kigoma Region
    "Buhigwe": { lat: -4.300, lng: 29.817 },
    "Kakonko": { lat: -3.283, lng: 30.967 },
    "Kasulu": { lat: -4.567, lng: 30.100 },
    "Kibondo": { lat: -3.583, lng: 30.717 },
    "Kigoma Urban": { lat: -4.883, lng: 29.633 },
    "Kigoma Rural": { lat: -4.950, lng: 29.700 },
    "Uvinza": { lat: -5.100, lng: 30.383 },
    // Kilimanjaro Region
    "Hai": { lat: -3.283, lng: 37.100 },
    "Moshi Urban": { lat: -3.3518, lng: 37.3417 },
    "Moshi Rural": { lat: -3.333, lng: 37.333 },
    "Mwanga": { lat: -3.650, lng: 37.667 },
    "Rombo": { lat: -3.017, lng: 37.583 },
    "Same": { lat: -4.067, lng: 37.733 },
    "Siha": { lat: -3.167, lng: 36.917 },
    // Lindi Region
    "Kilwa": { lat: -8.933, lng: 39.517 },
    "Lindi Urban": { lat: -10.000, lng: 39.717 },
    "Lindi Rural": { lat: -9.900, lng: 39.250 },
    "Liwale": { lat: -9.767, lng: 37.933 },
    "Nachingwea": { lat: -10.383, lng: 38.750 },
    "Ruangwa": { lat: -10.083, lng: 38.933 },
    // Manyara Region
    "Babati Urban": { lat: -4.217, lng: 35.750 },
    "Babati Rural": { lat: -4.250, lng: 35.750 },
    "Hanang": { lat: -4.433, lng: 35.400 },
    "Kiteto": { lat: -5.667, lng: 36.833 },
    "Mbulu": { lat: -3.850, lng: 35.550 },
    "Simanjiro": { lat: -4.133, lng: 36.567 },
    // Mara Region
    "Bunda": { lat: -2.450, lng: 33.867 },
    "Butiama": { lat: -2.050, lng: 33.967 },
    "Musoma Urban": { lat: -1.500, lng: 33.800 },
    "Musoma Rural": { lat: -1.583, lng: 33.750 },
    "Rorya": { lat: -1.583, lng: 34.333 },
    "Serengeti": { lat: -2.000, lng: 34.667 },
    "Tarime": { lat: -1.350, lng: 34.383 },
    // Mbeya Region
    "Busokelo": { lat: -9.217, lng: 33.867 },
    "Chunya": { lat: -8.550, lng: 33.417 },
    "Kyela": { lat: -9.583, lng: 33.833 },
    "Mbarali": { lat: -8.083, lng: 34.583 },
    "Mbeya City": { lat: -8.900, lng: 33.450 },
    "Mbeya Rural": { lat: -8.917, lng: 33.583 },
    "Rungwe": { lat: -9.133, lng: 33.667 },
    // Mjini Magharibi Region (Zanzibar)
    "Magharibi": { lat: -6.195, lng: 39.220 },
    "Mjini": { lat: -6.1659, lng: 39.2026 },
    // Morogoro Region
    "Gairo": { lat: -6.217, lng: 36.883 },
    "Kilombero": { lat: -8.133, lng: 36.683 },
    "Kilosa": { lat: -6.833, lng: 36.983 },
    "Morogoro Urban": { lat: -6.8225, lng: 37.6691 },
    "Morogoro Rural": { lat: -6.833, lng: 37.667 },
    "Mvomero": { lat: -6.250, lng: 37.450 },
    "Ulanga": { lat: -8.667, lng: 36.667 },
    // Mtwara Region
    "Masasi": { lat: -10.717, lng: 38.800 },
    "Mtwara Urban": { lat: -10.267, lng: 40.183 },
    "Mtwara Rural": { lat: -10.350, lng: 40.117 },
    "Nanyumbu": { lat: -10.667, lng: 38.500 },
    "Newala": { lat: -10.950, lng: 39.283 },
    "Tandahimba": { lat: -10.767, lng: 39.617 },
    // Mwanza Region
    "Ilemela": { lat: -2.548, lng: 32.945 },
    "Kwimba": { lat: -2.850, lng: 33.350 },
    "Magu": { lat: -2.583, lng: 33.433 },
    "Misungwi": { lat: -2.850, lng: 32.900 },
    "Nyamagana": { lat: -2.5195, lng: 32.9069 },
    "Sengerema": { lat: -2.350, lng: 32.617 },
    "Ukerewe": { lat: -1.900, lng: 33.000 },
    // Pemba North Region
    "Micheweni": { lat: -5.000, lng: 39.750 },
    "Wete": { lat: -5.050, lng: 39.733 },
    // Pemba South Region
    "Chake Chake": { lat: -5.250, lng: 39.767 },
    "Mkoani": { lat: -5.367, lng: 39.650 },
    // Pwani Region
    "Bagamoyo": { lat: -6.433, lng: 38.900 },
    "Kibaha": { lat: -6.783, lng: 38.917 },
    "Kisarawe": { lat: -7.133, lng: 39.050 },
    "Mafia": { lat: -7.917, lng: 39.667 },
    "Mkuranga": { lat: -7.133, lng: 39.183 },
    "Rufiji": { lat: -7.833, lng: 38.833 },
    // Rukwa Region
    "Kalambo": { lat: -8.333, lng: 31.333 },
    "Nkasi": { lat: -7.667, lng: 31.083 },
    "Sumbawanga Urban": { lat: -7.967, lng: 31.617 },
    "Sumbawanga Rural": { lat: -8.000, lng: 31.500 },
    // Ruvuma Region
    "Mbinga": { lat: -10.917, lng: 34.917 },
    "Songea Urban": { lat: -10.683, lng: 35.650 },
    "Songea Rural": { lat: -10.750, lng: 35.583 },
    "Tunduru": { lat: -11.083, lng: 37.350 },
    "Namtumbo": { lat: -10.467, lng: 36.167 },
    // Shinyanga Region
    "Kahama": { lat: -3.833, lng: 32.600 },
    "Kishapu": { lat: -3.617, lng: 33.867 },
    "Shinyanga Urban": { lat: -3.667, lng: 33.417 },
    "Shinyanga Rural": { lat: -3.750, lng: 33.417 },
    // Simiyu Region
    "Bariadi": { lat: -2.800, lng: 34.000 },
    "Busega": { lat: -2.433, lng: 33.450 },
    "Itilima": { lat: -3.000, lng: 34.000 },
    "Maswa": { lat: -3.167, lng: 33.800 },
    "Meatu": { lat: -3.500, lng: 34.500 },
    // Singida Region
    "Ikungi": { lat: -4.950, lng: 34.767 },
    "Iramba": { lat: -4.417, lng: 34.250 },
    "Manyoni": { lat: -5.750, lng: 34.833 },
    "Mkalama": { lat: -4.183, lng: 34.917 },
    "Singida Urban": { lat: -4.817, lng: 34.750 },
    "Singida Rural": { lat: -4.800, lng: 34.750 },
    // Songwe Region
    "Ileje": { lat: -9.333, lng: 33.250 },
    "Mbozi": { lat: -9.083, lng: 33.083 },
    "Momba": { lat: -8.833, lng: 32.500 },
    "Songwe": { lat: -8.700, lng: 32.800 },
    // Tabora Region
    "Igunga": { lat: -4.333, lng: 33.833 },
    "Kaliua": { lat: -5.067, lng: 31.783 },
    "Nzega": { lat: -4.217, lng: 33.183 },
    "Sikonge": { lat: -5.633, lng: 32.767 },
    "Tabora Urban": { lat: -5.017, lng: 32.800 },
    "Urambo": { lat: -5.067, lng: 32.050 },
    "Uyui": { lat: -5.000, lng: 32.833 },
    // Tanga Region
    "Handeni": { lat: -5.433, lng: 38.017 },
    "Kilindi": { lat: -5.583, lng: 37.583 },
    "Korogwe": { lat: -5.150, lng: 38.483 },
    "Lushoto": { lat: -4.783, lng: 38.283 },
    "Mkinga": { lat: -4.867, lng: 39.083 },
    "Muheza": { lat: -5.167, lng: 38.783 },
    "Pangani": { lat: -5.433, lng: 38.967 },
    "Tanga": { lat: -5.0889, lng: 39.1022 },
    // Unguja North Region
    "Kaskazini A": { lat: -5.933, lng: 39.267 },
    "Kaskazini B": { lat: -5.967, lng: 39.233 },
    // Unguja South Region
    "Kusini": { lat: -6.283, lng: 39.417 },
    "Kati": { lat: -6.167, lng: 39.333 },
};

